<template>
    <Layout class="bg-account">
        <Row type="flex" justify="center" align="middle" class="min-h-100vh py-5">
            <Col :xs="24" :md="22" :lg="20">
                <Card class="shadow">
                    <Row align="middle">
                        <Col :xs="24" :md="{ span: 16, offset: 4 }">
                            <h1 class="text-center text-24">{{ data.title }}</h1>
                        </Col>
                        <Col :xs="24">
                            <Descriptions bordered :column="1">
                                <DescriptionsItem v-for="p in data.present" :key="p.key" :label="$t(p.label)" size="small">
                                    <Date v-if="p.type === 'Datetime' && p.value4 && lodash.get(data.request, p.value4)" :text="lodash.get(data.request, p.value4)" format="DD/MM/YYYY HH:mm"></Date>
                                    <Date v-if="p.type === 'Datetime' && p.value3 && lodash.get(data.request, p.value3)" :text="lodash.get(data.request, p.value3)" format="DD/MM/YYYY HH:mm"></Date>
                                    <Date v-else-if="p.type === 'Datetime' && p.value2 && lodash.get(data.request, p.value2)" :text="lodash.get(data.request, p.value2)" format="DD/MM/YYYY HH:mm"></Date>
                                    <Date v-else-if="p.type === 'Datetime'" :text="lodash.get(data.request, p.value)" format="DD/MM/YYYY HH:mm"></Date>
                                    <Date v-else-if="p.type === 'Date' && p.value4 && lodash.get(data.request, p.value4)" :text="lodash.get(data.request, p.value4)" format="DD/MM/YYYY"></Date>
                                    <Date v-else-if="p.type === 'Date' && p.value3 && lodash.get(data.request, p.value3)" :text="lodash.get(data.request, p.value3)" format="DD/MM/YYYY"></Date>
                                    <Date v-else-if="p.type === 'Date' && p.value2 && lodash.get(data.request, p.value2)" :text="lodash.get(data.request, p.value2)" format="DD/MM/YYYY"></Date>
                                    <Date v-else-if="p.type === 'Date'" :text="lodash.get(data.request, p.value)" format="DD/MM/YYYY"></Date>
                                    <span v-else-if="p.type === 'eval' && p.value4 && eval(p.value4)({ ...data.request })">{{ eval(p.value4)({ ...data.request }) }}</span>
                                    <span v-else-if="p.type === 'eval' && p.value3 && eval(p.value3)({ ...data.request })">{{ eval(p.value3)({ ...data.request }) }}</span>
                                    <span v-else-if="p.type === 'eval' && p.value2 && eval(p.value2)({ ...data.request })">{{ eval(p.value2)({ ...data.request }) }}</span>
                                    <span v-else-if="p.type === 'eval'">{{ eval(p.value)({ ...data.request }) }}</span>
                                    <span v-else-if="p.type === 'static'">{{ p.value }}</span>
                                    <span v-else-if="p.value4 && lodash.get(data.request, p.value4)">{{ lodash.get(data.request, p.value4) }}</span>
                                    <span v-else-if="p.value3 && lodash.get(data.request, p.value3)">{{ lodash.get(data.request, p.value3) }}</span>
                                    <span v-else-if="p.value2 && lodash.get(data.request, p.value2)">{{ lodash.get(data.request, p.value2) }}</span>
                                    <span v-else>{{ lodash.get(data.request, p.value) || "-" }}</span>
                                </DescriptionsItem>
                            </Descriptions>
                            <div class="d-flex mt-3" v-if="data.router">
                                <router-link class="mx-auto" :to="{ name: data.router, params: { id: data.id } }">
                                    <Button class="btn-primary" :disabled="isLoading">
                                        <CIcon file="eye.svg"></CIcon>
                                        <span>{{ $t("button.showDetail") }}</span>
                                    </Button>
                                </router-link>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </Layout>
</template>

<script>
import { Card, Col, Layout, Row, Button, Descriptions } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../app.logic";
import { getShortDetail, isLoading } from "./request-short-detail.logic";
import lodash from "lodash";

export default defineComponent({
    components: {
        Card,
        Layout,
        Row,
        Col,
        Button,
        Descriptions,
        DescriptionsItem: Descriptions.Item,
        Date: defineAsyncComponent(() => import("../../../components/table/custom-render/Date")),
        CIcon: defineAsyncComponent(() => import("../../../components/icon/CIcon"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false }
    },
    setup(props) {
        const route = useRoute();
        const id = route.params?.id;
        const data = reactive({ id, title: null, request: null, router: null, present: null });
        const refs = reactive({ form: null });
        getShortDetail({ id }).then(res => {
            console.log(res)
            data.title = res.title;
            data.request = res.request;
            data.router = res.router;
            data.present = res.present;
        });
        return {
            props,
            data,
            refs,
            isLoading,
            lodash,
            eval
        };
    }
});
</script>

<style scoped>
.bg-account {
    background-image: url("../../../assets/bg/bg-account.jpg");
    background-size: 100% 100%;
}
</style>
